<template>
  <v-card class="mb-4">
    <v-card-text>
      <v-simple-table class="mt-3">
        <thead>
        <tr>
          <th>{{ $t('reports_ui.start_temp_log_report.user') }}</th>
          <th>{{ $t('reports_ui.start_temp_log_report.timestamp') }}</th>
          <th v-for="(product, index) in productHeaders" :key="index">
            {{ product }}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(entry, index) in report.results" :key="index">
          <td>{{ entry.user }}</td>
          <td>{{ formatTimestamp(entry.timestamp) }}</td>
          <td v-for="(temp, productName) in entry.products" :key="productName">
            {{ formatTemperature(temp) }}
          </td>
        </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'
import TemperatureConverterUtil from '@/util/TemperatureConverterUtil'
import Moment from 'moment-timezone'
export default {
  name: 'StartTempLogReport',
  mixins: [CurrentUserMixin],
  props: {
    report: {
      type: Object,
      required: true
    }
  },
  computed: {
    productHeaders() {
      const firstResultKey = Object.keys(this.report.results)[0];
      if (firstResultKey && this.report.results[firstResultKey].products) {
        return Object.keys(this.report.results[firstResultKey].products)
      }
      return []
    }
  },
  methods: {
    formatTemperature(temp) {
      if (temp === 'N/A') {
        return temp; // Return 'N/A' directly without conversion
      }
      const customerFormat = this.customerContext.tempFormat();
      const convertedTemp = TemperatureConverterUtil.to(temp, 'c', customerFormat.toLowerCase());
      return `${TemperatureConverterUtil.formatTemperature(convertedTemp)} °${customerFormat}`;
    },
    formatTimestamp(timestamp) {
      if (!timestamp) {
        return '';
      }
      const customerTimezone = this.customerContext.timezone();
      return Moment(timestamp).tz(customerTimezone).format('M/D/YYYY h:mm:ss A');
    }
  }
}
</script>

<style scoped lang="scss">
.table-header {
  font-size: 16px;
}
</style>
